export const projectStatusMap = {
    'C': 'closed',
    'A': 'active',
    'U': 'upcoming',
    'D': 'development',
    'R': 'release',
    'N': 'checklist_na',
    'ALL': 'all',
    'ADMIN': 'admin',
    'DT_P': 'datatracker_pending',
    'DT_A':'datatracker_progress',
    'DT_N': 'datatracker_na',
    'DT_C': 'datatracker_complete',
    'DT_D': 'datatracker_matched-duplicate',
    'DT_ALL': 'datatracker_all',
    'DT_H': 'datatracker_hold',
    'FMP_P': 'fmptracker_pending',
    'FMP_G': 'fmptracker_progress',
    'FMP_A': 'fmptracker_all',
    'FMP_R': 'fmptracker_review',
    'FMP_B': 'fmptracker_asbuilts',
    'FMP_C': 'fmptracker_complete',
};

export const projectStatusDisplayMap = {
    'C': 'Closed',
    'A': 'Active',
    'U': 'Upcoming',
    'D': 'In-Development',
    'R': 'Released',
    'N': 'Checklist N/A',
    'DT_P': 'Data Tracker Pending',
    'DT_A': 'Data Tracker In Progress',
    'DT_N': 'Data Tracker N/A',
    'DT_C': 'Data Tracker Complete',
    'DT_D': 'Data Tracker Matched/Duplicate',
    'DT_ALL':'Data Tracker All',
    'DT_H':'Data Tracker On Hold',
    'FMP_P': 'FMP Tracker Pending',
    'FMP_G': 'FMP Tracker In Progress',
    'FMP_A': 'FMP Tracker All',
    'FMP_R': 'FMP Tracker Under Review',
    'FMP_B': 'FMP Tracker As-Builts',
    'FMP_C': 'FMP Tracker Complete'

}

export const defaultCardsData = [{
    allProjectDescs: null,
    workOrder: null,
    bpid: null,
    mpid: null,
},
{
    allProjectDescs: null,
    workOrder: null,
    bpid: null,
    mpid: null,
},
{
    allProjectDescs: null,
    workOrder: null,
    bpid: null,
    mpid: null,
},
{
    allProjectDescs: null,
    workOrder: null,
    bpid: null,
    mpid: null,
}
,{
    allProjectDescs: null,
    workOrder: null,
    bpid: null,
    mpid: null,
},{
    allProjectDescs: null,
    workOrder: null,
    bpid: null,
    mpid: null,
},{
    allProjectDescs: null,
    workOrder: null,
    bpid: null,
    mpid: null,
},{
    allProjectDescs: null,
    workOrder: null,
    bpid: null,
    mpid: null,
},{
    allProjectDescs: null,
    workOrder: null,
    bpid: null,
    mpid: null,
},{
    allProjectDescs: null,
    workOrder: null,
    bpid: null,
    mpid: null,
}]